import { gql } from '@apollo/client';

export const CREATE_REPORTING_PERIOD_GROUP_MUTATOR = gql`
  mutation createReportingPeriodGroupMutator(
    $group_id: String
    $company_id: String
    $reporting_period_group_name: String
    $assigned_reporting_periods: [JSON]
    $user_email: String
  ) {
    createReportingPeriodGroup(
      group_id: $group_id
      company_id: $company_id
      reporting_period_group_name: $reporting_period_group_name
      assigned_reporting_periods: $assigned_reporting_periods
      user_email: $user_email
    )
  }
`;

export const UPDATE_REPORTING_PERIOD_GROUP_MUTATOR = gql`
  mutation updateReportingPeriodGroupMutator(
    $group_id: String
    $company_id: String
    $updated_reporting_period_group: JSON
    $original_reporting_period_group: JSON
    $user_email: String
  ) {
    updateReportingPeriodGroup(
      group_id: $group_id
      company_id: $company_id
      updated_reporting_period_group: $updated_reporting_period_group
      original_reporting_period_group: $original_reporting_period_group
      user_email: $user_email
    )
  }
`;

export const DELETE_REPORTING_PERIOD_GROUP_MUTATOR = gql`
  mutation deleteReportingPeriodGroupMutator(
    $group_id: String
    $company_id: String
    $reporting_period_group_id: String
    $reporting_period_group_name: String
    $unassigned_reporting_periods: [JSON]
    $user_email: String
  ) {
    deleteReportingPeriodGroup(
      group_id: $group_id
      company_id: $company_id
      reporting_period_group_id: $reporting_period_group_id
      reporting_period_group_name: $reporting_period_group_name
      unassigned_reporting_periods: $unassigned_reporting_periods
      user_email: $user_email
    )
  }
`;

export const ASSIGN_REPORTING_PERIOD_GROUP_MUTATOR = gql`
  mutation assignReportingPeriodGroup(
    $group_id: String
    $company_id: String
    $reporting_periods: [JSON]
    $reporting_period_group_id: String
    $user_email: String
  ) {
    assignReportingPeriodGroup(
      group_id: $group_id
      company_id: $company_id
      reporting_periods: $reporting_periods
      reporting_period_group_id: $reporting_period_group_id
      user_email: $user_email
    )
  }
`;
